/**
 * Convert PreparedDrop or ListsWithStatsRow to DropsWithStatsRow for ScaleDropModal reuse.
 * For Media Devoted | Created By Ciro Autiero
 */

import type {
  DropsWithStatsRow,
  ListsWithStatsRow,
  PreparedDrop,
} from '@/features/smswiser-campaigns/types/workspace.types';
import type { GatewayOption, LeadsListOption } from '@/features/smswiser-campaigns/components/drop-modals/drop-modals.types';

/** Convert ListsWithStatsRow[] to DropsWithStatsRow[] for create-from-lists flow. */
export function listsToDropsWithStatsRow(
  listRows: ListsWithStatsRow[],
  countryKey: string,
): DropsWithStatsRow[] {
  return listRows.map((r) => ({
    drop: {
      id: 0,
      uniqueId: `list-${r.listId}`,
      title: r.listName || r.listId,
      campaign: '',
      leadsList: r.listName || r.listId,
      country: countryKey,
      cap: 150,
      status: {},
      senderName: [],
      smsText: [],
      smsGatewayRoute: '',
      shortLinkTld: '',
    },
    voluumCampaignName: null,
    voluum: r.voluum,
  }));
}

export function preparedDropToDropsWithStatsRow(
  drop: PreparedDrop,
  gateways: GatewayOption[],
  leadsLists: LeadsListOption[],
): DropsWithStatsRow {
  const gateway = gateways.find((g) => g.id === drop.routeId);
  const leads = leadsLists.find((l) => l.id === drop.leadsListWiserId);
  const leadsListName = leads?.name ?? String(drop.leadsListWiserId);
  const gatewayName = gateway?.name ?? '';

  return {
    drop: {
      id: 0,
      uniqueId: drop.sentDropUniqueId ?? drop.id,
      title: drop.titleBase,
      campaign: '',
      leadsList: leadsListName,
      country: drop.countryKey,
      cap: drop.amount,
      status: {},
      executeAfter: drop.executeAfter ?? null,
      senderName: drop.senderNames ?? [],
      smsText: drop.smsTexts ?? [],
      smsGatewayRoute: gatewayName,
      shortLinkTld: drop.shortLinkTldValue ?? '',
    },
    voluumCampaignName: null,
    voluum: null,
  };
}
